/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

export const msalConfig = {
  auth: {
    clientId: import.meta.env.VITE_AZURE_CLIENT_ID,
    // clientId: '35df6651-bba4-40f9-b222-2167460bbd6e', // This is the ONLY mandatory field that you need to supply.

    authority:
      'https://login.microsoftonline.com/254ba93e-1f6f-48f3-90e6-e2766664b477',
    redirectUri: '/', // You must register this URI on Azure Portal/App Registration. Defaults to window.location.origin
    postLogoutRedirectUri: '/', // Indicates the page to navigate after logout.
    navigateToLoginRequestUrl: false, // If "true", will navigate back to the original request location before processing the auth code response.
  },
  cache: {
    cacheLocation: 'localStorage', // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
};

/*
App Name
	
Bliss


Application (client) ID
35df6651-bba4-40f9-b222-2167460bbd6e

Directory (Tenant) ID
254ba93e-1f6f-48f3-90e6-e2766664b477

App Type	
Web

ACP3/AAL3
No

Redirect URI
https://bliss.edaa.siemens-energy.cloud/oauth2/idpresponse
https://bliss-dev.edaa.siemens-energy.cloud/oauth2/idpresponse
https://bliss-uat.edaa.siemens-energy.cloud/oauth2/idpresponse


OAuth 2.0 authorization endpoint (v2)
https://login.microsoftonline.com/254ba93e-1f6f-48f3-90e6-e2766664b477/oauth2/v2.0/authorize


OAuth 2.0 token endpoint (v2)
https://login.microsoftonline.com/254ba93e-1f6f-48f3-90e6-e2766664b477/oauth2/v2.0/token
*/
